import { render, staticRenderFns } from "./BaseBlock.vue?vue&type=template&id=7a20e2bb&scoped=true&"
import script from "./BaseBlock.vue?vue&type=script&lang=js&"
export * from "./BaseBlock.vue?vue&type=script&lang=js&"
import style0 from "./BaseBlock.vue?vue&type=style&index=0&id=7a20e2bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a20e2bb",
  null
  
)

export default component.exports